import { jsx as _jsx } from "react/jsx-runtime";
import './AdvisorMiniPanel_Settings.scss';
import { PanelKey_Settings } from '../../../_shared.js';
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import { Component_HomeFooter } from '../../components/home-panel/Component_HomeFooter/Component_HomeFooter.js';
export class AdvisorMiniPanel_Settings extends AdvisorMiniPanel {
    //######################### Static #########################
    static defaultProps = {
        panelKey: PanelKey_Settings,
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve readonly mode into the state
        return state;
    }
    //######################### Render #########################
    renderFooter = undefined;
    renderSubHeader = undefined;
    renderHeader_Tail = undefined;
    renderContent = () => undefined;
    renderHeader_Title = () => _jsx(Component_HomeFooter, {});
}
//# sourceMappingURL=AdvisorMiniPanel_Settings.js.map